import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';

import { VideoEmbed as ArticleVideoEmbedProps } from 'lib/sanity/types';
import { BlockSerializerUbiContext } from 'lib/sanity/ui/BlockSerializerUbiProvider';

const VideoContainer = styled.div`
  position: relative;
  display: block;
  height: 0;
  padding: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
`;

const VideoEmbed = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border: 0;
  height: 100%;
  width: 100%;
`;

interface Props {
  videoEmbed: ArticleVideoEmbedProps;
}

const ArticleVideoEmbed = ({ videoEmbed }: Props) => {
  const vimeoId = videoEmbed?.video?.vimeoId;
  const ubi = useContext(BlockSerializerUbiContext);
  useEffect(() => {
    if (vimeoId) {
      ubi.logVideoImpression(vimeoId);
    }
  }, [ubi, vimeoId]);

  if (!videoEmbed.video || !videoEmbed.video.vimeoId) {
    return null;
  }
  return (
    <VideoContainer>
      <VideoEmbed
        title={videoEmbed.video.title}
        src={`https://player.vimeo.com/video/${videoEmbed.video.vimeoId}?wmode=opaque"`}
      />
    </VideoContainer>
  );
};

export default ArticleVideoEmbed;
